import React from 'react';
import { ButtonPaginationStyles as S } from './ButtonPagination.styles';
import { ReactComponent as Chevron } from '@img/icons/chevron-right.svg';
const ButtonPagination = ({ page, totalPages, onPageChange, disabled, }) => {
    if (totalPages === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(S.Pagination, null,
        React.createElement("small", null,
            "Page ",
            page,
            " of ",
            totalPages),
        React.createElement(S.ArrowButton, { direction: "left", onClick: () => onPageChange(page - 1), disabled: disabled || page === 1 },
            React.createElement(Chevron, null)),
        React.createElement(S.ArrowButton, { direction: "right", onClick: () => onPageChange(page + 1), disabled: disabled || page === totalPages },
            React.createElement(Chevron, null))));
};
export default ButtonPagination;
